//import images
import adobe from "../../assets/images/companies/adobe.svg";
import adobephotoshop from "../../assets/images/companies/adobe-photoshop.svg";
import airbnb from "../../assets/images/companies/airbnb.svg";
import amazon from "../../assets/images/companies/amazon.svg";
import flutter from "../../assets/images/companies/flutter.svg";
import mailchimp from "../../assets/images/companies/mailchimp.svg";
import line from "../../assets/images/companies/line.svg";
import spotify from "../../assets/images/companies/spotify.svg";
import wordpress from "../../assets/images/companies/wordpress.svg";
import upwork from "../../assets/images/companies/upwork.svg";
import sass from "../../assets/images/companies/sass.svg";
import reddit from "../../assets/images/companies/reddit.svg";

const jobsGridData = [
    {
        id: 1,
        img: adobe,
        title: "Magento Developer",
        location: "California"
    },
    {
        id: 2,
        img: adobephotoshop,
        title: "Product Designer",
        location: "UK"
    },
    {
        id: 3,
        img: airbnb,
        title: "Marketing Director",
        location: "USA"
    },
    {
        id: 4,
        img: amazon,
        title: "Project Manager",
        location: "California"
    },
    {
        id: 5,
        img: flutter,
        title: "HTML Developer",
        location: "Canada"
    },
    {
        id: 6,
        img: mailchimp,
        title: "Business Associate",
        location: "UK"
    },
    {
        id: 7,
        img: line,
        title: "Product Sales Specialist",
        location: "USA"
    },
    {
        id: 8,
        img: spotify,
        title: "Magento Developer",
        location: "Pakistan"
    },
    {
        id: 9,
        img: wordpress,
        title: "Magento Developer",
        location: "India"
    },
    {
        id: 10,
        img: upwork,
        title: "Magento Developer",
        location: "California"
    },
    {
        id: 11,
        img: sass,
        title: "Magento Developer",
        location: "Pakistan"
    },
    {
        id: 12,
        img: reddit,
        title: "Magento Developer",
        location: "India"
    },
];

const experienceData = [
    {
        id: 1,
        label: "All",
        value: "option1"
    },
    {
        id: 2,
        label: "Fresher",
        value: "option1"
    },
    {
        id: 3,
        label: "1-2",
        value: "option2"
    },
    {
        id: 4,
        label: "2-3",
        value: "option2"
    },
    {
        id: 5,
        label: "4+",
        value: "option3"
    }
]

const jobType = [
    {
        id: 6,
        label: "Full Time",
        value: "option3"
    },
    {
        id: 7,
        label: "Part Time",
        value: "option3"
    },
    {
        id: 8,
        label: "Freelance",
        value: "option3"
    },
    {
        id: 9,
        label: "Internship",
        value: "option3"
    }
]

export { jobsGridData, experienceData, jobType }